import config from './config.api';
import axiosRetry from 'axios-retry';
import { axiosWithHeaders } from '@innovyze/lib_get_service';

const assets = axiosWithHeaders({
	service: 'assets',
	config,
	axiosCreateOpts: {
		timeout: 10000,
	},
});

axiosRetry(assets, {
	retries: 3,
	retryDelay: retryCount => {
		return retryCount * 1000;
	},
});

export default assets;
